import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Terms = () => (
  <div className="min-h-screen max-w-3xl mx-auto px-6 py-10 text-white/85">
    <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white mb-6"><ArrowLeft size={16} /> Back</Link>
    <h1 className="font-display text-5xl text-white">Terms of Service</h1>
    <p className="text-white/50 text-sm mt-2">Last updated: {new Date().toLocaleDateString()}</p>

    <div className="mt-8 space-y-6 leading-relaxed">
      <section>
        <h2 className="text-xl font-semibold text-white">1. Acceptance</h2>
        <p>By using BLUNT TV (“Service”) you agree to these Terms. If you don’t agree, please don’t use the Service.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">2. Accounts</h2>
        <p>You sign in via Google. Keep your credentials secure. You are responsible for all activity on your account.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">3. Subscriptions & Billing</h2>
        <p>Paid plans renew automatically until canceled. Payments are processed by Square. You can cancel anytime from your account; cancellations take effect at the end of the current billing period. No refunds for partial months.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">4. Content</h2>
        <p>Movies and TV metadata are provided by TMDB. BLUNT Originals are licensed directly from independent creators. You may stream content for personal, non-commercial use only.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">5. Acceptable use</h2>
        <p>Don’t copy, redistribute, resell, or scrape content. Don’t attempt to bypass DRM or access controls.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">6. Termination</h2>
        <p>We may suspend or terminate accounts that violate these Terms or applicable law.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">7. Disclaimer</h2>
        <p>Service is provided “as is” without warranties. We are not liable for indirect or consequential damages.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">8. Contact</h2>
        <p>Questions about these Terms? Email <a className="text-[#E50914] hover:underline" href="mailto:ponomobiz@gmail.com">ponomobiz@gmail.com</a>.</p>
      </section>
    </div>
  </div>
);

export default Terms;
